import React from 'react';

import LetterTile from './letter-tile.jsx';
import ButtonBack from './button-back.jsx';
import ContactBadges from './contact-badges.jsx';
import MenuContacts from './menu-contacts.jsx';
import MenuStart from './menu-start.jsx';

import { sanitizeUrlForMime } from '../lib/utils.js';

export default class SideNavbar extends React.PureComponent {
  render() {
    const iconBadges = [];

    if (this.props.trustedBadges) {
      this.props.trustedBadges.forEach(b => {
        iconBadges.push({icon: b, color: 'badge-inv'});
      });
    }

    let avatar = null;

    if (this.props.tinode) {
      avatar = this.props.tinode.authorizeURL(
        sanitizeUrlForMime(this.props.avatar, 'image')
      );
    }

    return (
      <div id="side-caption-panel" className="caption-panel fox-v3-sidebar-head">

        <div className="fox-v3-brand">
          <div className="fox-v3-brand-logo" aria-hidden="true">
          <img src="img/vibe-messenger.svg" width="44" height="44" alt=""/>
        </div>

          <div className="fox-v3-brand-copy">
            <div className="fox-v3-brand-name">Vibe</div>
            <div className="fox-v3-brand-subtitle">Чаты. Контакты. Звонки.</div>
          </div>
        </div>

        <div className="fox-v3-sidebar-actions">
          {this.props.onCancel ?
            <ButtonBack onBack={this.props.onCancel} />
            :
            null}

          {this.props.state === 'login' ?
            <MenuStart
              onSignUp={this.props.onSignUp}
              onSettings={this.props.onSettings}
            />
            :
            this.props.state === 'contacts' ?
              <MenuContacts
                onNewTopic={this.props.onNewTopic}
                onSettings={this.props.onSettings}
              />
              :
              null}
        </div>

        {this.props.state === 'contacts' && <div className="fox-v4-sidebar-heading">
          <span>Чаты</span>
          <button
            type="button"
            className="fox-v4-new-chat"
            title="Новый чат"
            aria-label="Новый чат"
            onClick={this.props.onNewTopic}>
            <svg width="21" height="21" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm17.71-10.2a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z"/></svg>
          </button>
        </div>}

        <div className="fox-v3-profile-strip">
          {avatar ?
            <div id="self-avatar" className="avatar-box fox-v3-self-avatar">
              <LetterTile
                authorizeURL={this.props.tinode.authorizeURL}
                avatar={avatar}
                topic={this.props.myUserId}
                title={this.props.title}
              />
            </div>
            :
            <div className="fox-v3-self-avatar-placeholder">
              {this.props.title ? this.props.title.charAt(0).toUpperCase() : 'F'}
            </div>}

          <div className="fox-v3-profile-copy">
            <div
              id="sidepanel-title"
              className="panel-title fox-v3-profile-name"
            >
              {this.props.title}
              <ContactBadges badges={iconBadges}/>
            </div>

            <div className="fox-v3-profile-status">
              Ваш профиль
            </div>
          </div>
        </div>

      </div>
    );
  }
}
